module.exports = __webpack_public_path__ + "img/shoe2.3bf78b9d.svg";